import { render, staticRenderFns } from "./TypeArticles.vue?vue&type=template&id=ad605c4e&scoped=true"
import script from "./TypeArticles.vue?vue&type=script&lang=js"
export * from "./TypeArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad605c4e",
  null
  
)

export default component.exports